import { routerReducer } from "react-router-redux";
import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import action_store from "../reducers/action-store";
import listing from '../reducers/listing';
import listings from '../reducers/listings';
import listingPrice from '../reducers/listingPricing';
import calendarPrice from '../reducers/calendarPricing';
import entitlements from '../reducers/entitlements';
import calendar from '../reducers/calendar';
import nux from '../reducers/nux';
import sync from '../reducers/sync';
import spaceTags from '../reducers/spaceTags';
import space from '../reducers/space';
import spaces from '../reducers/spaces';
import modal from '../reducers/modal';
import inventory from '../reducers/inventory';
import payload from '../reducers/payload';
import add_ons from '../reducers/add-ons';
import attendees from '../reducers/attendees';
import auth from "../reducers/auth";
import contract from "../reducers/contracts";
import banner from "../reducers/banner";
import booking from '../reducers/booking';
import services from '../reducers/concierge';
import entities from "../reducers/entities";
import env from '../reducers/env';
import errors from "../reducers/errors";
import fee_profiles from "../reducers/fee-profile";
import fees from "../reducers/fees";
import flow from "../reducers/flow";
import invoices from "../reducers/invoices";
import nav from "../reducers/nav";
import payouts from "../reducers/payouts";
import profile from "../reducers/profile";
import reviews from "../reducers/reviews";
import vendors from "../reducers/vendors";
import workflows from "../reducers/workflows";
import { baseApi } from "../store/baseApi";

const rootReducer = combineReducers({
  routing: routerReducer,
  auth,
  attendees,
  nav,
  profile,
  booking,
  entities,
  services,
  errors,
  action_store,
  env,
  listing,
  listings,
  entitlements,
  calendar,
  nux,
  sync,
  spaces,
  modal,
  inventory,
  payload,
  add_ons,
  contract,
  reviews,
  listingPrice,
  calendarPrice,
  banner,
  payouts,
  flow,
  workflows,
  vendors,
  space,
  spaceTags,
  fee_profiles,
  fees,
  invoices,
  form: formReducer, // this needs to have the key of form
  // This is the RTK Query slice. It holds cached API responses, loading/error flags, and the
  // subscription counters that drive automatic cache eviction.
  [baseApi.reducerPath]: baseApi.reducer,
});

export default rootReducer;
